import Authenticated from 'src/components/Authenticated';

import BaseLayout from 'src/layouts/BaseLayout';

// import TopNavigationLayout from 'src/layouts/TopNavigationLayout';
import SideBarNavigation from 'src/layouts/AccentSidebarLayout';

import authRoutes from './auth';
import statusRoutes from './base';
import dashboardsRoutes from './dashboards';
import firmwareManagementRoutes from './firmwareManagement';
import inventoryManagementRoutes from './inventoryManagement';
import managementRoutes from './management';
import ordersRoutes from './orders';
import otherDashboards from './otherDashboards';
import publicRoutes from './public.route';
import reportsRoutes from './reports';

export const applicationRouter = [];

export const authenticationRouter = [];

const router = [
  {
    path: 'auth',
    children: authRoutes
  },

  // {
  //   path: 'certificate/:id',
  //   element: <CertificateLayout />,
  //   children: privateCertificateRoutes
  // },
  {
    path: 'public',
    children: publicRoutes
  },
  // {
  //   path: 'certificate/:id',
  //   element: <CertificateLayout />,
  //   children: privateCertificateRoutes
  // },
  {
    path: '*',
    element: <BaseLayout />,
    children: statusRoutes
  },
  {
    path: '',
    element: (
      <Authenticated>
        <SideBarNavigation />
      </Authenticated>
    ),
    children: [
      {
        path: '/',
        children: dashboardsRoutes
      }
      // {
      //   path: 'account/wallet',
      //   element: <BaseLayout />,
      //   children: [{ path: '/', element: <WalletView /> }]
      // }
    ]
  },
  {
    path: '',
    element: (
      <Authenticated>
        <SideBarNavigation />
      </Authenticated>
    ),
    children: [
      {
        path: '/dashboards',
        children: otherDashboards
      }
    ]
  },
  {
    path: '',
    element: (
      <Authenticated>
        <SideBarNavigation />
      </Authenticated>
    ),
    children: [
      {
        path: '/management',
        children: managementRoutes
      }
    ]
  },
  {
    path: '',
    element: (
      <Authenticated>
        <SideBarNavigation />
      </Authenticated>
    ),
    children: [
      {
        path: '/orders',
        children: ordersRoutes
      }
    ]
  },
  {
    path: '',
    element: (
      <Authenticated>
        <SideBarNavigation />
      </Authenticated>
    ),
    children: [
      {
        path: '/firmware-management',
        children: firmwareManagementRoutes
      }
    ]
  },
  {
    path: '',
    element: (
      <Authenticated>
        <SideBarNavigation />
      </Authenticated>
    ),
    children: [
      {
        path: '/inventory-management',
        children: inventoryManagementRoutes
      }
    ]
  },
  {
    path: '',
    element: (
      <Authenticated>
        <SideBarNavigation />
      </Authenticated>
    ),
    children: [
      {
        path: '/reports',
        children: reportsRoutes
      }
    ]
  }
  // {
  //   path: '',
  //   element: (
  //     <Authenticated>
  //       <SideBarNavigation />
  //     </Authenticated>
  //   ),
  //   children: [
  //     {
  //       path: '/view-operations',
  //       children: operationsRoute
  //     }
  //   ]
  // }
];

export default router;

export const filterRouter = (routes, filterFn) => {
  return routes
    .map((route) => {
      // filter child routes recursively
      // console.log("route is >>>>>>>>>>>>",route)
      if (route.children) {
        route.children = filterRouter(route.children, filterFn);
      }

      // if route has an id and user does NOT have permission → remove it
      if (route.id && !filterFn(route.id)) {
        return null;
      }

      return route;
    })
    .filter(Boolean); // remove nulls
};
